import { authenticatedFetch } from './auth';

// Cache for map preference to avoid repeated API calls
let mapPreferenceCache = null;
let mapPreferenceCacheTime = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const getUserMapPreference = async () => {
  // Check if we have a valid cached preference
  const now = Date.now();
  if (mapPreferenceCache && (now - mapPreferenceCacheTime) < CACHE_DURATION) {
    console.log('Using cached map preference:', mapPreferenceCache);
    return mapPreferenceCache;
  }

  try {
    const response = await authenticatedFetch('/map-preference');
    if (response.ok) {
      const data = await response.json();
      console.log('Fetched map preference from API:', data);
      mapPreferenceCache = {
        map_view_preference: data.map_view_preference,
        satellite_labels: data.satellite_labels
      };
      mapPreferenceCacheTime = now;
      return mapPreferenceCache;
    }
  } catch (error) {
    console.error('Error fetching map preference:', error);
  }
  
  // Return default if API call fails
  console.log('Using default map preference');
  return { map_view_preference: 'roadmap', satellite_labels: true };
};

export const clearMapPreferenceCache = () => {
  mapPreferenceCache = null;
  mapPreferenceCacheTime = 0;
};

export const getMapOptions = (mapType, satelliteLabels = true) => {
  console.log('getMapOptions called with:', { mapType, satelliteLabels });
  
  const options = {
    gestureHandling: 'greedy',
    mapTypeId: mapType || 'roadmap',
    // Keep POIs visible and clickable
    clickableIcons: true,
    // Disable the map type control (Map/Satellite toggle button)
    mapTypeControl: false
  };
  
  // For satellite view, control labels visibility
  if (mapType === 'satellite') {
    if (satelliteLabels) {
      // Satellite with labels - use hybrid
      options.mapTypeId = 'hybrid';
      console.log('Using hybrid map (satellite with labels)');
    } else {
      // Satellite without labels - use satellite but don't hide POI icons
      options.mapTypeId = 'satellite';
      // Don't use styles that hide POI icons
      console.log('Using satellite map without custom styles');
    }
  }
  
  console.log('Final map options:', options);
  return options;
};
